import { env } from '@zopauk/nextjs-env';
import { staticTheme } from '@/utils/theme';
import { PinoLogger } from '@zopauk/nextjs-logger';

export const { apiHandler, logger } = PinoLogger({
  environment: env('NEXT_PUBLIC_APP_ENV') || 'production', // uat | production | development
  applicationVersion: env('K8S_APP_VERSION') || 'dev',
  applicationName: env('NEXT_PUBLIC_APP_NAME') || '',
  sentryDSN: '',
  basePath: staticTheme().basePath,
});
